const csrfHeader = () => {
  const m = document.querySelector('meta[name="csrf-token"]');
  return m ? { 'X-CSRF-Token': m.content } : {};
};
const json = (r) => r.json().catch(() => ({}));

const attendanceApi = {
  today: (date) => {
    const qs = date ? `?date=${encodeURIComponent(date)}` : '';
    return fetch(`/class_sessions${qs}`, {
      headers: { Accept: 'application/json' }, credentials: 'same-origin',
    }).then(json);
  },
  session: (id) =>
    fetch(`/class_sessions/${id}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(json),
  bulkMark: (id, records) =>
    fetch(`/class_sessions/${id}/bulk_attendance`, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...csrfHeader() },
      body: JSON.stringify({ records }),
    }).then(json),
  cancel: (id, reason, grant_makeup_credits = true) =>
    fetch(`/class_sessions/${id}/cancel`, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...csrfHeader() },
      body: JSON.stringify({ reason, grant_makeup_credits }),
    }).then(json),
  // Single-session guest: at-the-door drop-in (arrive: 'present') or an
  // advance booking (arrive: 'booked').
  dropIn: (payload) =>
    fetch('/drop_ins', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...csrfHeader() },
      body: JSON.stringify(payload),
    }).then(json),
};

export default attendanceApi;
